import React from 'react';
import SEO from '../common/SEO';
import { motion } from 'framer-motion';

const AboutPage = () => {
  return (
    <>
      <SEO 
        title="O nás | LightWell – příběh experta na světelnou reklamu" 
        description="Příběh LightWell začal v roce 2010. Od výměny navigace na Letišti Praha až po komponenty, na které se výrobci reklamy mohou spolehnout."
        path="/o-nas"
      />
      <div className="pt-20">
        <section className="bg-gray-900 py-24 text-white relative overflow-hidden text-center">
          <div className="absolute inset-0 bg-blue-600/10 mix-blend-overlay"></div>
          <div className="max-w-7xl mx-auto px-4 relative z-10">
            <motion.h1 
              initial={{ opacity: 0, y: 20 }} 
              animate={{ opacity: 1, y: 0 }} 
              className="text-5xl md:text-7xl font-bold italic tracking-tighter uppercase mb-6"
            >
              O nás
            </motion.h1>
          </div>
        </section>

        <section className="py-24 bg-white">
          <div className="max-w-3xl mx-auto px-4 text-lg text-gray-700 leading-relaxed space-y-8">
            <p>
              Se světelnou reklamou jsem začal v roce 2010. Do ruky se mi tehdy dostala vizitka holandské firmy COMHAN a jejich světelné panely mě natolik zaujaly, že jsme se s Atlas Advertising Group s.r.o. domluvili na jejich distribuci pro český trh. Pod tím vznikl brand T-Board.cz.
            </p>
            <p>
              Pár měsíců po spuštění jsme s JCDecaux vyměnili všechny reklamní panely na Letišti Václava Havla a následně jsme s Letištěm Praha uzavřeli i zakázku na kompletní výměnu značení a navigace. Vyráběli jsme světelnou reklamu pro české i zahraniční značky, mezi nimi i fanouškovskou zónu na stadionu Chelsea, na kterou dodnes rád vzpomínám.
            </p>
            
            <figure className="my-12">
              <img 
                src="https://www.lightwell.cz/media/o-nas/letiste-vaclava-havla.webp" 
                alt="Světelné značení na Letišti Václava Havla" 
                className="w-full h-auto rounded-2xl shadow-xl"
              />
              <figcaption className="mt-4 text-center text-sm text-gray-500 italic">Výměna navigace na Letišti Praha</figcaption>
            </figure>

            <p>
              Roky výroby hotových panelů mě ale naučily jednu věc - kvalita reklamy stojí a padá na komponentech uvnitř. Na LED diodách, které nežloutnou po roce provozu. Na trafu, které vydrží nepřetržitý běh. Na konstrukci, kterou lze opravit bez nutnosti vyměnit celý panel.
            </p>

            <figure className="my-12">
              <img 
                src="https://www.lightwell.cz/media/o-nas/chelsea-fun-zona.webp" 
                alt="Fanouškovská zóna stadionu Chelsea" 
                className="w-full h-auto rounded-2xl shadow-xl"
              />
              <figcaption className="mt-4 text-center text-sm text-gray-500 italic">Fanouškovská zóna na stadionu Chelsea</figcaption>
            </figure>

            <p>
              Proto vznikl LightWell. Nedodáváme hotové reklamy, dodáváme to, z čeho je vyrábí ostatní - LED moduly, trafa a systém BlockLight pro rychlou montáž. Komponenty vybíráme od ověřených asijských výrobců, se kterými spolupracujeme přes 16 let, a testujeme je stejně přísně, jako bychom z nich sami stavěli panel na letiště.
            </p>
            <p>
              Pokud stavíte světelnou reklamu a hledáte dodavatele komponent, na kterého se dá spolehnout i po pěti letech provozu, ozvěte se.
            </p>
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutPage;